export default __webpack_public_path__ + "static/image14-12e22194db57017ee0d0cc16ce0d27c8.jpg";